import { render, staticRenderFns } from "./artist-tile.vue?vue&type=template&id=b0e48100&scoped=true"
import script from "./artist-tile.vue?vue&type=script&lang=js"
export * from "./artist-tile.vue?vue&type=script&lang=js"
import style0 from "./artist-tile.vue?vue&type=style&index=0&id=b0e48100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e48100",
  null
  
)

export default component.exports